// extracted by mini-css-extract-plugin
export default {"Socials":"Socials_Socials__BOwV6","iconContainer":"Socials_iconContainer__zQ0j0"};